import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import Layout from "@/layout";

export const constantRouterMap = [
  { path: "/", component: () => import("@/login"), name: "login" },
  { path: "/login", component: () => import("@/login"), name: "login" },
  {
    path: "/layout",
    component: Layout,
    name: "Layout",
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/page/home/index.vue"),
        meta: {
          hasFooter: true,
          title: "智慧园林 温馨家园"
        }
      },
      {
        path: "/monitor",
        name: "monitor",
        component: () => import("@/page/monitor/index.vue")
      },
      {
        path: "/illegal/",
        name: "Illegal",
        component: () => import("@/page/illegal/index.vue"),
        meta: {
          title: "非法占挖掘",
          hasFooter: true
        }
      },
      {
        path: "/maintenance",
        name: "Maintenance",
        component: () => import("@/page/maintenance/index.vue"),
        meta: {
          title: "占挖掘",
          hasFooter: true
        }
      },
      {
        path: "/check",
        name: "Check",
        component: () => import("@/page/check"),
        meta: {
          title: "对象查看",
          hasFooter: true
        }
      },
      {
        path: "/inspect",
        name: "Inspect",
        component: () => import("@/page/inspect"),
        meta: {
          title: "巡更",
          hasFooter: true
        }
      },
      {
        path: "/inspect/subpage/task",
        name: "task",
        component: () => import("@/page/inspect/subpage/task"),
        meta: {
          title: "今日任务",
          hasBack: true,
          backPath: "/inspect"
        }
      },
      {
        path: "/inspect/subpage/Grievance",
        name: "grievance",
        component: () => import("@/page/inspect/subpage/grievance"),
        meta: {
          title: "巡更申诉",
          hasBack: true,
          backPath: "/inspect"
        }
      },
      // 巡更再次申诉

      {
        path: "/inspect/subpage/againAppeal/:id",
        name: "againAppeal",
        component: () => import("@/page/inspect/subpage/againAppeal"),
        meta: {
          title: "申诉",
          hasBack: true
        }
      },
      {
        path: "/inspect/subpage/petrolhistory",
        name: "petrolhistory",
        component: () => import("@/page/inspect/subpage/petrolhistory"),
        meta: {
          title: "按照日期查找",
          hasBack: true,
          backPath: "/inspect"
        }
      },
      // 具体日期查记录
      {
        path: "/inspect/subpage/dayHistory/:time",
        name: "dayHistory",
        component: () => import("@/page/inspect/subpage/dayHistory"),
        meta: {
          title: "",
          hasBack: true,
          backPath: "/inspect/subpage/petrolhistory"
        }
      },
      // 批量申诉
      {
        path: "/inspect/subpage/batchgrievance/:time",
        name: "batchgrievance",
        component: () => import("@/page/inspect/subpage/batchgrievance"),
        meta: {
          title: "",
          hasBack: true
        }
      },
      // 巡更历史详情
      {
        path: "/inspect/subpage/historyDetail",
        name: "historyDetail",
        component: () => import("@/page/inspect/subpage/historyDetail"),
        meta: {
          title: "",
          hasBack: true
        }
      },

      {
        path: "/inspect/subpage/grievancecontent/:time",
        name: "grievancecontent",
        component: () => import("@/page/inspect/subpage/grievancecontent"),
        meta: {
          title: "",
          hasBack: true,
          backPath: "/inspect/subpage/Grievance"
        }
      },
      // {
      //   path: "/inspect/history",
      //   name: "inspectHistory",
      //   component: () => import("@/page/inspect/subpage/history"),
      //   meta: {
      //     title: "巡更记录",
      //     hasFooter: true,
      //   }
      // },
      {
        path: "/inspect/report/:id",
        name: "inspectReport",
        component: () => import("@/page/inspect/subpage/report"),
        meta: {
          title: "巡更",
          hasBack: true
        }
      },
      {
        path: "/inspect/position",
        name: "InspectPosition",
        component: () => import("@/page/inspect/subpage/position"),
        meta: {
          title: "巡更点位置",
          hasBack: true
        }
      },
      {
        path: "/check/detail",
        name: "CheckDetail",
        component: () => import("@/page/check/subpage/detail"),
        meta: {
          hasMore: true,
          hasBack: true,
          backPath: "/check"
        }
      },
      {
        path: "/check/edit",
        name: "checkEdit",
        component: () => import("@/page/check/subpage/edit"),
        meta: {
          title: "编辑"
        }
      },
      {
        path: "/collect",
        name: "Collect",
        component: () => import("@/page/collect"),
        meta: {
          title: "对象采集",
          hasFooter: true
        }
      },
      {
        path: "/collect/detail",
        name: "CollectDetail",
        component: () => import("@/page/collect/subpage/detail"),
        meta: {
          hasMore: true,
          hasBack: true,
          backPath: "/collect"
        }
      },
      {
        path: "/collect/edit",
        name: "collectEdit",
        component: () => import("@/page/collect/subpage/edit"),
        meta: {
          title: "编辑"
        }
      },
      {
        path: "/collect/add",
        name: "collectAdd",
        component: () => import("@/page/collect/subpage/add"),
        meta: {
          title: "添加"
        }
      },
      {
        path: "/map",
        name: "map",
        component: () => import("@/page/map")
      },
      {
        path: "/mine",
        name: "mine",
        component: () => import("@/page/mine"),
        meta: {
          title: "我的",
          hasFooter: true
        }
      },
      {
        path: "/clockIn",
        name: "clockIn",
        component: () => import("@/page/clockIn"),
        meta: {
          title: "公厕巡检",
          hasFooter: false
        }
      },
      {
        path: "/hygienism",
        name: "hygienism",
        component: () => import("@/page/hygienism"),
        meta: {
          title: "卫情上报",
          hasFooter: true
        }
      },
      {
        path: "/issue",
        name: "issue",
        component: () => import("@/page/issue"),
        meta: {
          title: "督查检查",
          hasFooter: true
        }
      },
      {
        path: "/delayIssue",
        name: "delayIssue",
        component: () => import("@/page/delayIssue"),
        meta: {
          title: "延时申请",
          hasFooter: true,
          hasBack: true
        }
      },
      {
        path: "/issue/add",
        name: "issudAdd",
        component: () => import("@/page/issue/subpage/add"),
        meta: {
          title: "上报",
          hasBack: true,
          backPath: "/issue"
        }
      },
      {
        path: "/issue/detail/:id/:distance",
        name: "issueDetail",
        component: () => import("@/page/issue/subpage/detail"),
        meta: {
          title: "详情",
          hasBack: true
        }
      },
      {
        path: "/issue/detailOfFinishedIssue/:id",
        name: "detailOfFinishedIssue",
        component: () => import("@/page/issue/subpage/detailOfFinishedIssue"),
        meta: {
          title: "详情",
          hasBack: true
        }
      },
      {
        path: "/issue/subpage/manageDetail/:id",
        name: "manageDetail",
        component: () => import("@/page/issue/subpage/manageDetail"),
        meta: {
          title: "处理",
          hasBack: true
        }
      },
      {
        path: "/issue/detailOfFinishedIssue",
        name: "issudDetailOfFinishedIssue",
        component: () => import("@/page/issue/subpage/detailOfFinishedIssue"),
        meta: {
          title: "详情"
        }
      },

      {
        path: "/issue/detailItem",
        name: "detailItem",
        component: () => import("../components/detailItem.vue"),
        meta: {
          title: "处理",
          hasBack: true
        }
      },
      {
        path: "/supervise",
        name: "supervise",
        component: () => import("@/page/supervise"),
        meta: {
          title: "考核任务",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/supervise/appraisee",
        name: "appraisee",
        component: () => import("@/page/supervise/appraisee"),
        meta: {
          title: "考核对象",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/supervise/appraisee/map",
        name: "map",
        component: () => import("@/page/supervise/appraisee/map.vue"),
        meta: {
          title: "考核对象",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/supervise/appraisee/detail",
        name: "detail",
        component: () => import("@/page/supervise/appraisee/detail.vue"),
        meta: {
          title: "考核详情",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/houseSupervise",
        name: "houseSupervise",
        component: () => import("@/page/houseSupervise"),
        meta: {
          title: "入户宣导",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/garbageCollection",
        name: "garbageCollection",
        component: () => import("@/page/garbageCollection"),
        meta: {
          title: "垃圾收运",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/personnel",
        name: "personnel",
        component: () => import("@/page/personnel"),
        meta: {
          title: "人事审批",
          hasFooter: true,
          hasBack: true
        }
      },
      {
        path: "/personnel/detail",
        name: "initiateDetail",
        component: () => import("@/page/personnel/detail"),
        meta: {
          title: "审批详情",
          hasBack: true
        }
      },
      {
        path: "/personnel/initiate",
        name: "initiate",
        component: () => import("@/page/personnel/initiate"),
        meta: {
          title: "新增申请",
          hasBack: true
        }
      },
      {
        path: "/personnel/initiate/form",
        name: "initiateFrom",
        component: () => import("@/page/personnel/initiate/form"),
        meta: {
          title: "申请单据填写",
          hasBack: true
        }
      },
      {
        path: "/personnel/initiate/list",
        name: "initiate",
        component: () => import("@/page/personnel/initiate/list"),
        meta: {
          title: "我发起的",
          hasBack: true
        }
      },
      {
        path: "/personnel/approve",
        name: "approve",
        component: () => import("@/page/personnel/approve"),
        meta: {
          title: "我审批的",
          hasBack: true
        }
      },
      {
        path: "/error",
        name: "error",
        component: () => import("@/page/error/index"),
        meta: {
          title: "状态异常"
        }
      },
      {
        path: "/scan",
        name: "scan",
        component: () => import("@/page/scan"),
        meta: {
          title: "车辆绑定",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/maintenanceWork",
        name: "maintenanceWork",
        component: () => import("@/page/maintenanceWork"),
        meta: {
          title: "养护作业",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/maintenanceWork/add",
        name: "maintenanceWorkAdd",
        component: () => import("@/page/maintenanceWork/add"),
        meta: {
          title: "新增作业任务",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/maintenanceWork/detail",
        name: "maintenanceWorkDetail",
        component: () => import("@/page/maintenanceWork/detail"),
        meta: {
          title: "查看作业任务",
          hasBack: true,
          hasFooter: true
        }
      },
      {
        path: "/maintenanceWork/complete",
        name: "maintenanceWorkComplete",
        component: () => import("@/page/maintenanceWork/complete"),
        meta: {
          title: "完成作业任务",
          hasBack: true,
          hasFooter: true
        }
      },
    ]
  }
];

export default new Router({
  // mode:'history',
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js